module.exports = __webpack_public_path__ + "static/Frontier_Communications_Corporation_logo_2016-c434aaff1e94ce0eb5cd83d13fff9aa5.svg";